import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Cabinet Stomatologic</h3>
            <p className="text-gray-300">Servicii stomatologice de calitate în Oradea.</p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Linkuri Utile</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-white">Acasă</Link></li>
              <li><Link to="/doctors" className="text-gray-300 hover:text-white">Doctori</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-white">Servicii</Link></li>
              <li><Link to="/gallery" className="text-gray-300 hover:text-white">Galerie foto</Link></li>
              <li><Link to="/appointment" className="text-gray-300 hover:text-white">Programare</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Str. Iza nr. 15</li>
              <li>Oradea, România</li>
              <li>+40 259 268 304</li>
              <li>artisanstoma@gmail.com</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Program</h4>
            <ul className="space-y-2 text-gray-300">
              <li>Luni - Joi: 9:00 - 21:00</li>
              <li>Vineri: 9:00 - 19:00</li>
              <li>Sâmbătă: Închis</li>
              <li>Duminică: Închis</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Artisan Stoma, Toate drepturile rezervate.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
